import { authGet } from "@api/auth/auth";
import { DEPLOYMENT_URL } from "@constants";
import { FeatureFlagsResponse } from "@types";

export const getFeatureFlags = (
  deploymentId: string
): Promise<FeatureFlagsResponse> => {
  const path = `${DEPLOYMENT_URL}/${deploymentId}/features`;
  return authGet<FeatureFlagsResponse>(path);
};
